// extracted by mini-css-extract-plugin
export default {"EventLog":"_EventLog--jLwhY","EventValue":"_EventValue--l4mdO","Label":"_Label--lxDj2"};